import NumberRangePickerController from './number-range-picker.controller';
import { NumberRangePickerProps } from './number-range-picker.model';

const NumberRangePicker = (props: NumberRangePickerProps) => {
  return <NumberRangePickerController {...props} />;
};

export default NumberRangePicker;
